module.exports = __webpack_public_path__ + "static/img/wx.3673d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx.png
// module id = ZDm/
// module chunks = 1